@for (detail of details; track detail) {
  <!-- Guest name -->
  @if (detail?.headline) {
    <div class="spa-detail-area-container spa-detail-area-headline" data-testid="guest_details_headline">
      {{ detail.headline }}
    </div>
  }
  <!-- Further Data, Companions, Status -->
  @if (detail?.sectionTitle) {
    <div class="spa-detail-area-container spa-detail-area-section-title">{{ detail.sectionTitle }}</div>
  }

  <!-- Price, Discount Price, Discount Reason, Payer -->
  @if (detail?.label || detail?.data?.text || detail?.data?.textByFunction) {
    <div class="spa-detail-area-container" data-testid="guest_detail">
      @if (detail?.label) {
        <div class="spa-detail-area-text spa-detail-area-container-label" data-testid="guest_detail_label">
          {{ detail.label }}
        </div>
      }
      @if (detail?.data?.text) {
        <div
          class="spa-detail-area-text spa-detail-area-container-data"
          [ngStyle]="detail?.data?.styling"
          data-testid="additional_booking_detail_payer_and_companions"
        >
          {{ detail.data.text }}
        </div>
      }

      @if (detail?.data?.textByFunction) {
        <div
          class="spa-detail-area-text spa-detail-area-container-data"
          [ngStyle]="detail?.data?.styling"
          data-testid="additional_booking_detail_price_and_discounts"
        >
          {{ getText(detail.data) }}
        </div>
      }
    </div>
  }

  <!-- Product(s), Tickets, Status -->
  @if (detail?.html) {
    <div class="spa-detail-area-container">
      <ng-container *ngTemplateOutlet="detail.html | getSpaSlot: contentTemplate()"></ng-container>
    </div>
  }
}
